// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ddt?societaId&ordineId',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","tipo":"VENDITA|CANTIERE","stato":"BOZZA|EMESSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","_count":{"righe":"number"}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/distinte/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","commessaId":"number","ordineId":"number","numero":"number","tipo":"MERCE|LAVORAZIONI","addebito":"NOSTRO|CLIENTE","descrizione":"string","stato":"BOZZA|CONFERMATA","confermataAt":"string","createdAt":"string","ordine":{"id":"number","numero":"string","stato":"string","flussoCommerciale":"string","societaId":"number"},"commessa":{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"},"confermataDa":{"id":"number","nome":"string","cognome":"string"},"createdBy":{"id":"number","nome":"string","cognome":"string"},"righe":[{"id":"number","ordinePos":"number","rigaOrdineId":"number","componenteId":"number","articoloId":"number","descrizione":"string","quantita":"number","unitaMisura":"string","note":"string","articolo":{"id":"number","codice":"string","descrizioneBase":"string","tipologia":"string"},"rigaOrdine":{"id":"number","ordinePos":"number","descrizione":"string"}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/distinte/:id/conferma',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"CONFERMATA","confermataAt":"string"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/distinte/:id/riporta-in-bozza',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"BOZZA"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/distinte/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/distinte/:id',
    requestBody: '{"descrizione":"string","addebito":"NOSTRO|CLIENTE"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/distinte/:id',
    requestBody: '{"righe":[{"rigaOrdineId":"number|null","componenteId":"number|null","articoloId":"number|null","descrizione":"string","quantita":"number","unitaMisura":"string|null","note":"string|null"}]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
